import {
  Directive,
  Input,
  ElementRef,
  Renderer2,
  OnChanges,
  SimpleChanges,
  inject
} from '@angular/core';
import { LoanProductDscrSummary } from '@app/app/interfaces/tax-data/dscr-data-summary.struct';

@Directive({
  selector: '[appDscrProductStatusIcon]',
  standalone: true
})
export class DscrProductStatusIconDirective implements OnChanges {
  @Input('appDscrProductStatusIcon') product: LoanProductDscrSummary | undefined;
  private readonly PASSING_CLASS = 'passing';
  private readonly FAILING_CLASS = 'failing';
  private _el = inject(ElementRef);
  private _renderer = inject(Renderer2);

  private _isPassingAllRatios(): boolean {
    if (!this.product || !this.product.productDscrResults) {
      return false;
    }
    return this.product.productDscrResults.every(result => {
      return result.meetsRequiredGlobalRatio && result.meetsRequiredBusinessRatio;
    });
  }

  private _updateIconAndClass(): void {
    const isPassing = this._isPassingAllRatios();
    const iconName = isPassing ? 'check_circle' : 'cancel';

    // set mat-icon based on pass/fail
    this._renderer.setProperty(this._el.nativeElement, 'textContent', iconName);

    // apply and remove classes based on pass/fail
    if (isPassing) {
      this._renderer.removeClass(this._el.nativeElement, this.FAILING_CLASS);
      this._renderer.addClass(this._el.nativeElement, this.PASSING_CLASS);
    } else {
      this._renderer.removeClass(this._el.nativeElement, this.PASSING_CLASS);
      this._renderer.addClass(this._el.nativeElement, this.FAILING_CLASS);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['product']) {
      this._updateIconAndClass();
    }
  }
}
